import { Show } from "shared/components";
import { has } from "shared/utils";
import { VerificationSchemaNames } from "types/landlord/verificationTemplate";
import { AuditSummaryFlag } from "views/applications-id/components/ApplicantsTable/components/AuditSummaryFlag";
import { Cell } from "views/applications-id/components/ApplicantsTable/components/Cell";
import { ReportStatusBadge } from "views/applications-id/components/ApplicantsTable/components/ReportStatusBadge";
import {
  FullApplicant,
  Verification
} from "views/applications-id/components/ApplicantsTable/types";

export const HousingHistorySection = ({
  applicant,
  verification,
  hasAuditFlagEnabled,
  verificationSchemas
}: {
  verification: Verification;
  hasAuditFlagEnabled: boolean;
  applicant: FullApplicant;
  verificationSchemas?: VerificationSchemaNames;
}) => {
  return (
    <>
      <Cell isDataCell className="relative">
        {has(verification.summary?.total_number_of_residences) ? (
          verification.summary.total_number_of_residences
        ) : hasAuditFlagEnabled ? (
          <AuditSummaryFlag
            audit_summary_flags={applicant.audit_summary_flags}
          />
        ) : (
          "-"
        )}
        <ReportStatusBadge
          applicantStatus={applicant.application_status}
          verificationStatus={verification.status}
          executionMode={verification.settings?.execution_mode}
        />
      </Cell>
      <Cell isDataCell>
        {has(verification.summary?.average_monthly_payment_amount) ? (
          verification.summary.average_monthly_payment_amount
        ) : hasAuditFlagEnabled ? (
          <AuditSummaryFlag
            audit_summary_flags={applicant.audit_summary_flags}
          />
        ) : (
          "-"
        )}
      </Cell>
      <Cell isDataCell>
        {has(verification.summary?.total_months_of_residence) ? (
          verification.summary.total_months_of_residence
        ) : hasAuditFlagEnabled ? (
          <AuditSummaryFlag
            audit_summary_flags={applicant.audit_summary_flags}
          />
        ) : (
          "-"
        )}
      </Cell>

      <Show if={has(verificationSchemas?.rental_verification)}>
        <Cell isDataCell>
          {has(verification.summary?.completed_surveys_count) &&
          has(verification.summary.total_surveys_count) ? (
            <>
              <span>
                {verification.summary.completed_surveys_count}/
                {verification.summary.total_surveys_count}
              </span>
              <span className="ml-1 text-content-300">surveys completed</span>
            </>
          ) : hasAuditFlagEnabled ? (
            <AuditSummaryFlag
              audit_summary_flags={applicant.audit_summary_flags}
            />
          ) : (
            "-"
          )}
        </Cell>
      </Show>
    </>
  );
};
